import { PropsOf } from 'types';
import connect from './connect';
import Redirect from './Redirect';

const ConnectedComponent = connect(Redirect);
export type RedirectProps = PropsOf<typeof ConnectedComponent>;

export default ConnectedComponent;
